import { normalizeWorkBuddyGroups } from '../workBuddyAuthorize/workBuddyAuthorize.utils'

export const isWorkBuddyMembershipPath = (path: string): boolean =>
  path.toLowerCase().replace(/\/+$/, '') === '/workbuddy/membership'

// 不回落到浏览器中上次选中的团队，避免给其他团队购买。
export const resolveMembershipGroup = (groups: unknown, search: string) => {
  const id = new URLSearchParams(search).get('groupId')?.trim()
  if (!id) return undefined
  return normalizeWorkBuddyGroups(groups).find(
    (group) => group.id === id || group.inviteId === id
  )
}

export const membershipBindURL = (search: string, code: string): string => {
  const query = new URLSearchParams(search)
  query.delete('code')
  query.delete('state')
  query.set('token', code)
  query.set('bind', '1')
  return `/workbuddy/membership?${query}`
}
